import React from 'react';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.any,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDetail: PropTypes.func.isRequired,
};

const defaultProps = {
  title: null,
  data: [],
  columns: [],
  onEdit: () => {
  },
  onDetail: () => {
  },
};

function UsersDataTable({
  title,
  data,
  columns,
  onEdit,
  onDetail,
}) {
  return (
    <MaterialTable
      title={title}
      columns={columns}
      options={{
        rowStyle: {
          textAlign: 'left',
          verticalAlign: 'top',
        },
        search: false,
        actionsColumnIndex: 0,
        pageSize: 10
      }}
      actions={[
        {
          icon: () => (<EditIcon/>),
          tooltip: 'Edit',
          iconProps: { color: 'primary' },
          onClick: (event, rowData) => onEdit(rowData)
        },
        {
          icon: () => (<InfoIcon/>),
          tooltip: 'Detail',
          iconProps: { color: 'primary' },
          onClick: (event, rowData) => onDetail(rowData)
        }
      ]}
      data={data}
    />
  );
}

UsersDataTable.propTypes = propTypes;
UsersDataTable.defaultProps = defaultProps;
export default UsersDataTable;



// WEBPACK FOOTER //
// ./src/components/UsersDataTable/index.jsx